import { render, staticRenderFns } from "./wechat_commitTrial.vue?vue&type=template&id=7b7fcebf&scoped=true"
import script from "./wechat_commitTrial.vue?vue&type=script&lang=js"
export * from "./wechat_commitTrial.vue?vue&type=script&lang=js"
import style0 from "./wechat_commitTrial.vue?vue&type=style&index=0&id=7b7fcebf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7fcebf",
  null
  
)

export default component.exports